import Api from '../../app/services/api';

const getBreakdown = (id) => Api.get(`/breakdown/${id}`);

const getBreakdowns = (params) => Api.get('/breakdown', params);

const saveBreakdown = (params) => Api.post('/breakdown', params);

const updateBreakdown = (params) => Api.put(`/breakdown/${params.id}`, params);

const getBreakdownStatuses = (params) => Api.get('/breakdown/status', params);

const saveBreakdownStatus = (params) => Api.post(`/breakdown/${params.id}/status`, params);

const deleteBreakdown = (id) => Api.delete(`/breakdown/${id}`);

export {
  getBreakdown,
  getBreakdowns,
  saveBreakdown,
  deleteBreakdown,
  updateBreakdown,
  saveBreakdownStatus,
  getBreakdownStatuses,
};
